export default "__VITE_ASSET__RIOePZJg__"